import { render, staticRenderFns } from "./skills-card.vue?vue&type=template&id=47c24b54&"
import script from "./skills-card.vue?vue&type=script&lang=js&"
export * from "./skills-card.vue?vue&type=script&lang=js&"
import style0 from "./skills-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports